import { useQuery, QueryStatus } from '@tanstack/react-query';
import { queryFn } from './queryFn';
import { selector } from './selector';
import type { Entity } from './types';
import { persistedQueryConfig } from '@/utilities/persistQueryClient/utilities';

export const QUERY_KEY = ['DASHBOARD_FEED'] as const;

interface Response {
  status: QueryStatus;
  isFetching: boolean;
  keys: string[];
  entities: Record<string, Entity>;
  isFetched: boolean;
}

export default function useFeed(): Response {
  const {
    data = { keys: [], entities: {} },
    status,
    isFetched,
    isFetching,
  } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => queryFn(),
    retry: 1,
    notifyOnChangeProps: ['data', 'error'],
    select: selector,
    ...persistedQueryConfig,
  });

  const { keys, entities } = data;

  return {
    keys,
    entities,
    isFetching,
    status,
    isFetched,
  };
}
